import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { TempiKpi } from "./DashboardInsights";

// Tempi (mediana) in Panoramica: tutti i lead commerciali, periodo fisso da inizio anno.
export default function PanoramicaTempi() {
  const [tempi, setTempi] = useState(null);
  useEffect(() => {
    api.get("/dashboard/my-priorities", { params: { period: "year" } }).then((r) => setTempi(r.data.tempi || {})).catch(() => setTempi({}));
  }, []);
  return (
    <div data-testid="panoramica-tempi">
      <div className="flex justify-end mb-2">
        <span className="text-xs text-muted-foreground border border-border rounded px-3 py-1.5" data-testid="tempi-period-label">Da inizio anno ({new Date().getFullYear()})</span>
      </div>
      {tempi && <TempiKpi tempi={tempi} />}
    </div>
  );
}
